import reduceReducers from 'reduce-reducers';
import { reducer as formReducer } from 'redux-form';
import { CLEAR_SUBMIT_ERROR, INITIALIZE_FORM_FIELDS, INITIALIZE_FORM_FIELD } from '../consts';
import { deleteInWithCleanUp } from '../../utils/object';

export const customFormReducer = reduceReducers(formReducer, (state, action) => {
	switch (action.type) {
		case INITIALIZE_FORM_FIELD: {
			const { formName, fieldName, value } = action.payload;

			if (
				typeof state[formName] === 'undefined' ||
				typeof state[formName].initial !== 'object' ||
				typeof state[formName].values !== 'object'
			) {
				return state;
			}

			return {
				...state,
				[formName]: {
					...state[formName],
					initial: {
						...state[formName].initial,
						[fieldName]: value,
					},
					values: {
						...state[formName].values,
						[fieldName]: value,
					},
				},
			};
		}
		case INITIALIZE_FORM_FIELDS: {
			const { formName, formValues } = action.payload;

			if (typeof state[formName] === 'undefined') {
				return state;
			}

			return {
				...state,
				[formName]: {
					...state[formName],
					initial: {
						...(state[formName]?.initial || {}),
						...formValues,
					},
					values: {
						...(state[formName]?.values || {}),
						...formValues,
					},
				},
			};
		}
		case CLEAR_SUBMIT_ERROR: {
			const { formName, fieldName } = action.payload;

			if (typeof state[formName] === 'undefined' || typeof state[formName].submitErrors !== 'object') {
				return state;
			}

			return deleteInWithCleanUp(state, `${formName}.submitErrors.${fieldName}`);
		}

		default:
			return state;
	}
});
